import { useContext } from 'react'
import { AdOperatorReportIoContext } from './AdOperatorReportIoProvider'

export const useAdOperatorReportIo = () => {
  const AdOperatorReportIoProviderValue = useContext(AdOperatorReportIoContext)

  if (!AdOperatorReportIoProviderValue) {
    throw new Error(
      'useAdOperatorReportIo must be used within an AdOperatorReportIoProvider',
    )
  }

  return AdOperatorReportIoProviderValue
}
